import React from 'react';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import 'date-fns';
import es from "date-fns/locale/es";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBInput,
    MDBBtn,
    MDBModalFooter,
    MDBModal,
    MDBModalBody
} from 'mdbreact';

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import axios from 'axios';

import "react-datepicker/dist/react-datepicker.css";

require('dotenv').config();

const isMorethanToday = (someDate) => {
    const today = new Date()
    return someDate.getTime() > today.getTime()
}

registerLocale('es', es)
class PrecitaPacientesForm extends React.Component {

    constructor(props) {
        super(props);
        this.dataform = {
            nombre:'',
            apellidos:'',
            telefono:'',
            aseguradora:'',
            modalidad:null,
            descripcion_estudio:'',
            fecha_solicitada:null,
            hora_solicitada:'',
            minutos:'',
            nombre_modalidad:'',
            descripcion_modalidad:'',
            hora_inicio:null,
            hora_fin:null,

            template:"",
            destination:"",
            api_url:"",
            notificationsAPIEndopoint:"",
            appointmentsAPiEndpoint:""
        };

        this.state = {
            debug:false,
            showAlert: false,
            errorMessage:"Error: Debe informar una fecha posterior a hoy para poder solicitar una cita",
            sentMessage:"Su petición de cita ha sido efectuada correctamente. Intentaremos ponernos en contacto con usted lo mas pronto posible a través del número de teléfono que ha informado. Muchas gracias.",
            mailSent:false,
            selectedClass:'notSelected',

            showValidation:false,
            validationMessage:"Some fields are incorrect. Review your information.",

            calendarcenter:{
                workingDays:[],
                holydays:[]
            },
            modalities:[],
            timeRanges:[],
            busyHours:[],

            lang:{
                header_text:'',
                first_name:'',
                last_name:'',
                phone_text:'',
                insurance_text:'',
                modality_text:'',
                studydescription_text:'',
                selectdate_text:'',
                selecttime_text:'',
                submitbutton_text:''
            }
        };

        this.errorMessage = '';

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleInsuranceChange = this.handleInsuranceChange.bind(this);
        this.handleStudyDescriptionChange = this.handleStudyDescriptionChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleModalityChange = this.handleModalityChange.bind(this);
        this.handleHourChange = this.handleHourChange.bind(this);
        this.getAppointments = this.getAppointments.bind(this);
    }


    createTimeOptions(modality,busyHours){

        console.log("Creating Time options for modality: "+modality);
        console.log("BUSYHOURS: ",busyHours);

        var modalities = this.state.modalities;
        console.log("ALL MODALITIES: ",modalities);
        var idModality = modality;
        var modalitySelected=null;
        modalities.forEach(function(modality){
            console.log("ID:"+modality.id);
            console.log("Modalidad:"+modality.name);
            if(modality.id==idModality) modalitySelected = modality
        });

        this.dataform.minutos = modalitySelected.minutes;
        this.dataform.nombre_modalidad = modalitySelected.name;
        this.dataform.descripcion_modalidad = modalitySelected.description;

        console.log("SELECTED MODALITY = ",modalitySelected);

        /*** CODE ***/
        var x = modalitySelected.minutes; //minutes interval
        var rangeHours = []; // time array
        var tt = 0; // start time

        //loop to increment the time and push results in array
        for (var i=0;tt<24*60; i++) {
            var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
            var mm = (tt%60); // getting minutes of the hour in 0-55 format
            //times[i] = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
            var valString = ("0" + (hh%24)).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 12:00 AM/PM format]

            if((valString>=modalitySelected.initTime && valString<=modalitySelected.endTime) && busyHours.indexOf(valString)===-1){
                rangeHours[i]={value:valString,label:valString,disabled:false};
            }
            if((valString>=modalitySelected.initTime && valString<=modalitySelected.endTime) && busyHours.indexOf(valString)!==-1){
                rangeHours[i]={value:valString,label:valString,disabled:true};
            }
            tt = tt + x;
        }

        console.log(rangeHours);

        /*** END CODE ***/

        return rangeHours;
    }
    calculateEndHour(initHour,rangeMinutes){
        var hour = parseInt(initHour.split(":")[0]);
        var minutes = parseInt(initHour.split(":")[1]);
        var tt = (hour*60)+minutes+rangeMinutes;
        var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
        var mm = (tt%60); // getting minutes of the hour in 0-55 format
        //times[i] = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
        var valString = ("0" + (hh%24)).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 12:00 AM/PM format]
        return valString;
    }
    handleFirstNameChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.nombre = event.target.value;
        }

    }
    handleLastNameChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.apellidos = event.target.value;
        }
    }
    handlePhoneChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.telefono = event.target.value;
        }
    }
    handleInsuranceChange(event) { this.dataform.aseguradora = event.target.value; }
    handleStudyDescriptionChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.descripcion_estudio = event.target.value;
        }
    }
    handleModalityChange(event) {

        console.log("NUeva modalidad = "+event.target.value);
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.modalidad = event.target.options[event.target.selectedIndex].value;

            if(this.dataform.fecha_solicitada){
                console.log("TENEMOS MODALIDAD Y FECHA. CARGAMOS LAS CITAS");
                this.getAppointments(this.dataform.fecha_solicitada)
                    .then((busyHours) => {
                        console.log("Citas cargadas desde Modality");
                        //var busyHours=this.state.busyHours;
                        this.setState({
                            timeRanges:this.createTimeOptions(this.dataform.modalidad,busyHours)
                        });
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
            this.setState({
                selectedClass:"modalitySelected"
            });
        }

    }
    handleModalityFocused(event){
        document.getElementById("ModalityLabel").classList.add("active");
    }
    handleHourChange(event) {
        event.target.isValid=true;
        this.dataform.hora_solicitada = event.target.options[event.target.selectedIndex].value;
        this.dataform.hora_inicio=this.dataform.hora_solicitada;
        this.dataform.hora_fin=this.calculateEndHour(this.dataform.hora_inicio,this.dataform.minutos);
    }

    handleHourFocused(event){
        document.getElementById("HourLabel").classList.add("active");
    }
    handleDateChange = date => {
        this.dataform.fecha_solicitada=date;
        if(this.dataform.modalidad && date){
            console.log("TENEMOS FECHA Y MODALIDAD. CARGAMOS LAS CITAS");
            this.setState({
                selectedDate: date
            });
            this.getAppointments(date)
                .then((busyHours) => {
                    console.log("Citas cargadas desde Date");
                    //var busyHours=this.state.busyHours;
                    this.setState({
                        timeRanges:this.createTimeOptions(this.dataform.modalidad,busyHours)
                    });
                })
                .catch((error) => {
                    console.log(error)
                })

        }else{
            this.setState({
                selectedDate: date
            });
        }
    };

    getData(){
        const myRequest = new Request(process.env.REACT_APP_RESOURCES_PATH+'precitapacientes/config.json');
        fetch(myRequest)
            .then(response => response.json())
            .then(data=>{
                this.dataform.destination = data.emailAddress;
                this.dataform.template = data.emailTemplate;
                this.dataform.api_url = data.urlApi;
                this.dataform.notificationsAPIEndopoint = data.urlApi+data.notificationsAPIEndopoint;
                this.dataform.appointmentsAPIEndpoint=data.urlApi+data.appointmentsAPIEndpoint;
                this.dataform.saveAppointmentsAPIEndpoint=data.urlApi+data.saveAppointmentsAPIEndpoint;
            });
    }

    isWeekday = (date) => {
        const day = date.getDay();
        const dateTime = date.getTime();
        const offset = this.state.calendarcenter.offsetDays

        var habil=true;
        this.state.calendarcenter.workingDays.forEach(function(notWorkingDay){
            if(day===notWorkingDay){
                habil=false;
                return;
            }
            if((dateTime-new Date().getTime())/(1000*3600*24)<=offset){
                habil=false;
                return;
            }
        });
        if(habil){
            return habil;
        }
    }
    createDisabledDays(days){

        var disabledDays = [];
        //1º Deshabilitamos los días de vacaciones
       /* days.map(function(day){
            var timestamp = Date.parse(day.month+"/"+day.day+"/"+new Date().getFullYear());
            var oDate = new Date(timestamp);
            console.log("El día es: ",days);
            disabledDays.push(oDate);
        });*/
        disabledDays.push(days.map(function(day){
            var timestamp = Date.parse(day.month+"/"+day.day+"/"+new Date().getFullYear());
            var oDate = new Date(timestamp);
            return oDate;
        }));

        return disabledDays;
    }
    createNotWorkingDays(days){
        var notWorkingDays = [];
        //1º Deshabilitamos los días no hábiles
        days.map(function(day){
            if(!day.active){
                notWorkingDays.push(day.weekDay);
            }
        });

        return notWorkingDays;
    }

    getCalendarCenter(){
        const myRequest = new Request(process.env.REACT_APP_RESOURCES_PATH+'precita/calendarCenter.json');
        fetch(myRequest)
            .then(response => response.json())
            .then(data=>{
                /*this.state.calendarcenter.workingDays=data.workingDays;*/
                this.setState({
                    calendarcenter:{
                        holidays:this.createDisabledDays(data.holidays),
                        workingDays:this.createNotWorkingDays(data.workingDays),
                        offsetDays:data.offsetDays
                    }
                });
            });
    }
    getModalities(){
        const myRequest = new Request(process.env.REACT_APP_RESOURCES_PATH+'precita/modalities.json');
        fetch(myRequest)
            .then(response => response.json())
            .then(data=>{
                this.setState({
                    modalities:data.modalities
                });
            });
    }
    formatDateForAppointments(date){
        if(date){
            return date.getFullYear()+"/"+((date.getMonth()+1<10)?"0"+(date.getMonth()+1):(date.getMonth()+1))+"/"+((date.getDate()<10)?"0"+(date.getDate()):(date.getDate()));
        }


    }
    getAppointments(date){
        return new Promise((resolve, reject) => {
            console.log("STATE DATE LOADED:"+date);
            var formattedDate = this.formatDateForAppointments(date);
            var debug=false;
            if(debug){
                //Simulamos que la petición se lanza y devuelve success=true, y un array de items (citas) ocupadas
                var response = {
                    client: null,
                    count: 0,
                    error: null,
                    items: ["10:00","11:30"],
                    jsonMessage: null,
                    logMessages: [],
                    message: "Appointments found for selected date",
                    request_type: null,
                    requested_id: null,
                    requested_method: null,
                    status: 200,
                    success: true,
                    temporalFile: null,
                    value: ""
                };
                console.log("RESPONSE = ",response);
                var busyHours =response.items;
                resolve(busyHours);
            }else{
                axios({
                    method: 'post',
                    url: `${this.dataform.appointmentsAPIEndpoint}`,
                    headers: { 'content-type': 'application/json' },
                    data: '{"date":"'+formattedDate+'","modality":"'+this.dataform.modalidad+'"}'
                }).then(result => {
                    console.log("RESPUESTA: ",result);
                    if(result.status===200){
                        console.log("RESPUESTA(STATUS): ",result.status);

                        if(result.data.success){
                            console.log("RESPUESTA(success): ")

                            this.setState(
                                { busyHours: result.data.items }
                                );
                            resolve(result.data.items)
                        }else{
                            reject(false);
                        }
                    }else{
                        this.setState(
                            { error: result.data.message }
                        )
                    }
                }).catch(error => {
                        reject(error.message);
                    }
                );
            }
        })

    }
    getLang(){

        var pathname = window.location.pathname;
        var alias_array = pathname.split( '/' );
        var last_segment = alias_array.pop();
        var alias = last_segment;
        if(alias=="") {
            alias = alias_array[alias_array.length-1];
        }

        var lang = "es.json";
        switch(alias){
            case 'patiententermin':
                lang = "de.json";
                this.dataform.lang="de";
                break;
            case 'patientpreappointment':
                lang = "en.json";
                this.dataform.lang="en";
                break;
            case 'precitapacientes':
                lang = "es.json";
                this.dataform.lang="es";
                break;
        }
        const myRequest = new Request(process.env.REACT_APP_RESOURCES_PATH+'patientpreappointment/lang/'+lang);
        fetch(myRequest)
            .then(response => response.json())
            .then(data=>{
                this.setState({
                    lang:{
                        header_text:data.header_text,
                        firstname_text:data.firstname_text,
                        lastname_text:data.lastname_text,
                        phone_text:data.phone_text,
                        insurance_text:data.insurance_text,
                        modality_text:data.modality_text,
                        studydescription_text:data.studydescription_text,
                        selectdate_text:data.selectdate_text,
                        selecttime_text:data.selecttime_text,
                        submitbutton_text:data.submitbutton_text,
                        usercreationsuccess_text:data.usercreationsuccess_text
                    }
                })
                this.state.sentMessage = data.usercreationsuccess_text;
            });
    }
    componentDidMount(){
        this.getLang();
        this.getData();
        this.getCalendarCenter();
        this.getModalities();
    }
    handleSubmit(event) {
        event.preventDefault();
        let formIsValid = true;

        var components=document.getElementsByClassName("form-control");
        var inputList = Array.prototype.slice.call(components);

        console.log("INPUTS = ",components);

        var invalidcomponents="Invalid Components: ";
        inputList.forEach(function(component){
            if(component.required){
                if(!component.isValid){
                    //console.log("Componente inválido ",component);
                    invalidcomponents=invalidcomponents+component.name+", ";
                    event.target.className += " is-invalid";
                    formIsValid=false;
                }else{
                    event.target.className += " was-validated";
                    //console.log("Componente válido");
                }
            }
        });
        console.log("El FORM ES VALIDO: "+formIsValid);
        this.dataform.invalidcomponents=invalidcomponents.slice(0, -2);

        if(formIsValid){
            //event.target.className += " was-validated";
            this.sendInfo();
        }else{
            this.setState({
                showValidation: true
            });
        }
    }
    sendInfo(){
        axios({
            method: 'post',
            url: `${this.dataform.saveAppointmentsAPIEndpoint}`,
            headers: { 'content-type': 'application/json' },
            data: this.dataform
        }).then(result => {
            if(result.status===200){
                if(result.data.success){
                    this.setState(
                        { mailSent: true }
                    );

                }else{
                    this.setState(
                        {
                            showSQLAlert:true,
                            sqlErrorMessage: this.parseSqlError(result.data)
                        }
                    )
                }
            }else{
                this.setState(
                    { error: result.data.message }
                )
            }
        }).catch(error => {
                this.setState(
                    { error: error.message }
                )
            }
        );
    }
    handleNotShowMessage(){
        console.log("NOT SHOWING");
        this.setState({
            showAlert: false
        });
    }

    toggle = () => {
        this.setState({
            showAlert: !this.state.showAlert
        });
    };
    toggleMail = () => {
        this.setState({
            mailSent:  !this.state.mailSent,
        });
        if(this.state.mailSent){
            window.location.reload();
        }
    };
    toggleSql = () => {
        this.setState({
            showSQLAlert:  !this.state.showSQLAlert,
        });
    };
    toggleValidation = () => {
        this.setState({
            showValidation:  !this.state.showValidation,
        });
    };
    cancelCourse = () => {
        document.getElementById("registerMunchenForm").reset();
    }

    render() {
        return (
          <div className="row d-flex justify-content-center">
            <div className="col-md-8 modal-lg">
                <MDBContainer>
                    <MDBModal isOpen={this.state.mailSent} toggle={this.toggleMail} size="lg" centered>
                        <MDBModalBody>
                            <img className="successImage" alt="success" src={'../greenStick.svg.png'} />
                            {this.state.sentMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleMail}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>

                <MDBContainer>
                    <MDBModal isOpen={this.state.showSQLAlert} toggle={this.toggleSql} side position="top-right" dismiss>
                        <MDBModalBody>
                            {this.state.sqlErrorMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleSql}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>
                <MDBContainer>
                    <MDBModal isOpen={this.state.showValidation} toggle={this.toggleValidation} side position="top-right" dismiss>
                        <MDBModalBody>
                            {this.state.validationMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleValidation}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>

                    <MDBContainer>
                        <MDBModal isOpen={this.state.showAlert} toggle={this.toggle} side position="top-right" dismiss>
                            <MDBModalBody>
                                {this.state.errorMessage}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    </MDBContainer>

              <form onSubmit={this.handleSubmit}>
                <MDBContainer>
                    <MDBRow>
                      <MDBCol>
                        <MDBCard>
                          <MDBCardBody className="mx-4">
                              <img className="logo" src={ process.env.REACT_APP_RESOURCES_PATH+'precitapacientes/logo_resona.jpg'} alt="logoCentro" />
                            <div className="text-center">
                              <h3 className="dark-grey-text mb-5">
                                <strong>{this.state.lang.header_text}</strong>
                              </h3>
                            </div>
                            <MDBInput
                                className="mb-3"
                                type="text"
                                label={this.state.lang.firstname_text}
                                name="first_name"
                                onChange={this.handleFirstNameChange}
                                required
                            />
                            <MDBInput
                                label={this.state.lang.lastname_text}
                                type="text"
                                name="last_name"
                                onChange={this.handleLastNameChange}
                                required
                            />

                              <MDBInput
                                type="text"
                                label={this.state.lang.phone_text}
                                name="telefono"
                                onChange={this.handlePhoneChange}
                                required
                              />

                              <MDBInput
                                  type="text"
                                  label={this.state.lang.insurance_text}
                                  name="aseguradora"
                                  onChange={this.handleInsuranceChange}
                              />

                              <div className="md-form">
                                  <select required
                                      className={this.state.selectedClass + " browser-default custom-select treatment-select form-control"}
                                      name="modality"
                                      onChange={this.handleModalityChange}
                                      onFocus={this.handleModalityFocused}
                                  >
                                      <option hidden disabled selected></option>
                                      {this.state.modalities.map(({ id, description }, index) => <option value={id}>{description}</option>)}
                                  </select>
                                  <label className="" data-error="" data-success="" id="ModalityLabel">
                                      {this.state.lang.modality_text}
                                  </label>
                              </div>

                              <MDBInput
                                  type="text"
                                  label={this.state.lang.studydescription_text}
                                  name="descripcion_estudio"
                                  onChange={this.handleStudyDescriptionChange}
                              />


                              <div className="row">
                                  <div className="col">
                                      <label className="text-black-50" width="100%">{this.state.lang.selectdate_text}</label>
                                      <div className="text-left mt-auto mb-3">
                                          <DatePicker
                                              class=""
                                              dateFormat="dd/MM/yyyy"
                                              locale="es"
                                              selected={this.state.selectedDate}
                                              onChange={this.handleDateChange}
                                              minDate={new Date()}
                                              excludeDates={this.state.calendarcenter.holidays}
                                              filterDate={this.isWeekday}
                                              required
                                          />
                                      </div>
                                  </div>
                                  <div className="col">
                                      <div className="md-form">
                                          <select className={this.state.selectedClass + " browser-default custom-select treatment-select"}
                                                  id="cbTimeSelector"
                                                  name="modality"
                                                  onChange={this.handleHourChange}
                                                  onFocus={this.handleHourFocused}
                                                  disabled = {this.state.selectedDate==null || this.dataform.modalidad==null?true:false}
                                                  required
                                          >
                                              <option hidden disabled selected></option>
                                              {(this.state.debug)?<option value="10:00" >10:00</option>:this.state.timeRanges.map(({ value, label,disabled }, index) => <option value={value} disabled={disabled}>{label}</option>)}

                                          </select>
                                          <label className="" data-error="" data-success="" id="HourLabel">
                                              {this.state.lang.selecttime_text}
                                          </label>
                                      </div>
                                  </div>
                              </div>


                            <div className="text-center mb-3">
                              <MDBBtn
                                  type="submit"
                                  value="Submit"
                                  gradient="blue"
                                  rounded
                                  className="btn-block z-depth-1a"
                              >
                                  {this.state.lang.submitbutton_text}
                              </MDBBtn>
                            </div>
                          </MDBCardBody>

                          <MDBModalFooter className="mx-5 pt-3 mb-1">
                            <p className="font-small grey-text d-flex justify-content-end muypequeña">
                              Developed by IST Medical
                            </p>
                          </MDBModalFooter>
                        </MDBCard>
                      </MDBCol>
                    </MDBRow>
                </MDBContainer>
              </form>
          </div>
          </div>
      );
    }


    parseSqlError(data){
        var errorCodeMsg = data.logMessages[data.logMessages.length -1];
        var errorCode = (errorCodeMsg.replace("[SQL_ERR_Code] - ","")).trim();

        if(errorCode === 1062){
            return "Doctor KV already exists. Have you forgotten your credentials?";
        }else{
            return data.message;
        }
    }
}

export default PrecitaPacientesForm;

